// The Axios configuration file axiosConfig.ts is imported.
// This ensures that Axios is configured with CSRF token handling
// and other settings before any component or service uses it.

import App from './App.vue'; // Components
import ClickTrackerService from '@/services/admin_actions/clickTrackerService'; // Import the Click Tracker Service
import { createApp } from 'vue'; // Composables
import { registerPlugins } from '@/plugins'; // Plugins
import '@/styles/_index.scss'; // Global styles
import $ from 'jquery';
import 'virtual:svg-icons-register';
import router from '@/router'; // Import the router
import { CapacitorUpdater } from '@capgo/capacitor-updater'
import { checkForUpdates } from './services/mobile_app/liveUpdateService';
import { setSafeAreaInsets } from './services/mobile_app/safeAreaService';
CapacitorUpdater.notifyAppReady();

// Extend the Window interface to include 'router'
declare global {
  interface Window {
	router: typeof router;
  }
}


//import jquery and the jquery ui and the jquery cropper
(window as any).$ = (window as any).jQuery = $;

setSafeAreaInsets();

const app = createApp(App); // Create the app

registerPlugins(app);
app.mount('#app');

// Initialize the Click Tracker Service without arguments
const clickTracker = new ClickTrackerService();
clickTracker.init();

window.router = router; // Make the router globally accessible

checkForUpdates(); // Check for updates on app load